import { render, staticRenderFns } from "./predictiontable.vue?vue&type=template&id=748cab2c&"
import script from "./predictiontable.vue?vue&type=script&lang=js&"
export * from "./predictiontable.vue?vue&type=script&lang=js&"
import style0 from "./predictiontable.vue?vue&type=style&index=0&id=748cab2c&prod&lang=css&"
import style1 from "./predictiontable.vue?vue&type=style&index=1&id=748cab2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports